/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  OrganizationUserAdminDTOQueryResultDTO,
  TeacherGetTeachersFromOrganizationParams
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





export const teacherGetTeachersFromOrganization = (
    organizationId: number,
    params?: TeacherGetTeachersFromOrganizationParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<OrganizationUserAdminDTOQueryResultDTO>(
      {url: `/api/organizations/${organizationId}/admin/Teacher`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getTeacherGetTeachersFromOrganizationQueryKey = (organizationId: number,
    params?: TeacherGetTeachersFromOrganizationParams,) => {
    return [`/api/organizations/${organizationId}/admin/Teacher`, ...(params ? [params]: [])] as const;
    }

    
export const getTeacherGetTeachersFromOrganizationQueryOptions = <TData = Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError = ErrorType<unknown>>(organizationId: number,
    params?: TeacherGetTeachersFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTeacherGetTeachersFromOrganizationQueryKey(organizationId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>> = ({ signal }) => teacherGetTeachersFromOrganization(organizationId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organizationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TeacherGetTeachersFromOrganizationQueryResult = NonNullable<Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>>
export type TeacherGetTeachersFromOrganizationQueryError = ErrorType<unknown>


export function useTeacherGetTeachersFromOrganization<TData = Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params: undefined |  TeacherGetTeachersFromOrganizationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>,
          TError,
          Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeacherGetTeachersFromOrganization<TData = Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: TeacherGetTeachersFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>,
          TError,
          Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTeacherGetTeachersFromOrganization<TData = Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: TeacherGetTeachersFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useTeacherGetTeachersFromOrganization<TData = Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError = ErrorType<unknown>>(
 organizationId: number,
    params?: TeacherGetTeachersFromOrganizationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof teacherGetTeachersFromOrganization>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTeacherGetTeachersFromOrganizationQueryOptions(organizationId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



